<!-- <ng-container *ngIf="activity_data_loaded">
    <app-activity-template-v2 [data]="activity_data" (activityDetailsClosed)="activityDetailsClosed($event)"></app-activity-template-v2>
</ng-container> -->

<div class="page-section">
    <ng-container *ngIf="activity_data_loaded">
        <div class="dashboard-container">
            <div class="client-header">
                <div class="action-items-label">
                    <div class="action-iten-nav" (click)="back()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="13px" height="13px" fill="currentColor">
                            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
                        </svg> 
                        Back
                    </div>
                </div>
                <div class="opportunity-summary-heading-section">
                    <span>Opportunity Summary</span>
                </div>
                <div class="client-name-row">
                    <h1 class="client-name">
                        <span>{{activity_data.user_name}}</span>
                        <span class="client-badge-top">{{activity_data.type_label}}</span>
                        <!-- <span class="client-badge-top">{{activity_data.user_type}}</span> -->
                    </h1>
                    <p class="client-subtext">
                        <span *ngIf="activity_data.relationship != '' && activity_data.relationship != null">{{activity_data.relationship}} &bull; </span>
                        <!-- <span *ngIf="activity_data.user_type == 'Client'">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(activity_data.invested_aum)}} invested AUM</span> -->
                        <span *ngIf="activity_data.user_type == 'Client'">{{activity_data.invested_aum}} invested AUM</span>
                    </p>
                </div>
                
                <div class="client-metrics" *ngIf="user_role == 'Advisor' || user_role == 'AFA' || user_role == 'Assistant'">
                    <div>
                        <div class="metric-title">Objective</div>
                        <div class="metric-value highlight-objective">{{activity_data.objective}}</div>
                    </div>
                    <div>
                        <div class="metric-title">Opportunity Value</div>
                        <div class="metric-value highlight">{{activity_data.opportunity}}</div>
                    </div>
                    <div>
                        <div class="metric-title">Time to close deal</div>
                        <div class="metric-value time">
                            <svg class="clock-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <circle cx="12" cy="12" r="10"/>
                                <polyline points="12 6 12 12 16 14"/>
                            </svg> 
                            {{activity_data.predicted_closure_days}} Day(s)
                        </div>
                    </div>
                </div>

                <div class="client-metrics">
                    <div>
                        <div class="metric-title">Activity</div>
                        <div class="metric-value">
                            {{activity_data.communication_type_name}}
                            <ng-container *ngIf="activity_data.email_template != null && user_role != 'Advisor Manager' && user_role != 'Executive' &&  user_role != 'Wholesaler'">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="view-email-icon" (click)="openActivityEmailPreviewModal(activity_data)">
                                    <!-- Document / Email Preview Inside -->
                                    <path d="M7 3h10v4H7z" fill="#ffffff" />
                                    <line x1="9" y1="5" x2="15" y2="5" />
                                    <path d="M5 7h14v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7z" fill="#ffffff" />
                                    <line x1="9" y1="11" x2="15" y2="11" />
                                    <line x1="9" y1="14" x2="13" y2="14" />
                                    <!-- Inbox Tray Base -->
                                    <path d="M3 15h4l2 3h6l2-3h4" />
                                    <path d="M3 9v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9" />
                                </svg>
                            </ng-container>
                        </div>
                        <!-- <textarea placeholder="Name . . ." class="custom-input" style="resize: none;" [(ngModel)]="activity_data.name"></textarea> -->
                    </div>
                    <div>
                        <div class="metric-title">Description</div>
                        <div class="metric-value">{{activity_data.name}}</div>
                        <!-- <textarea placeholder="Description . . ." class="custom-input" style="resize: none;" [(ngModel)]="activity_data.description"></textarea> -->
                    </div>
                    <!-- <div>
                        <div class="metric-title">Communication Channel</div>
                        <div class="metric-value">{{activity_data.communication_type_name}}</div>
                        <select class="custom-input" style="height: 60px;" [(ngModel)]="activity_data.communication_type">
                            <option [value]="''">Select Communication Channel</option>
                            <option *ngFor="let communication_channel of communication_type_list" [value]="communication_channel.id">{{communication_channel.name}}</option>
                        </select>
                    </div> -->
                    <div *ngIf="user_role == 'Advisor' || user_role == 'AFA'">
                        <div class="metric-title">Assign to</div>
                        <div class="metric-value">{{activity_data.afa_name}}</div>
                        <!-- <select class="custom-input" style="height: 60px;" [(ngModel)]="activity_data.afa_id">
                            <option [value]="''">Self</option>
                            <option *ngFor="let afa of afa_list" [value]="afa.id" (click)="activity_data.afa_name = afa.first_name + ' ' + afa.last_name">{{ afa.first_name }} {{ afa.last_name }}</option>
                        </select> -->
                    </div>
                </div>

            </div>

            <!-- Main Grid Area -->
            <div class="main-grid">
                
                <!-- Left Column -->
                <div class="left-column">
                    
                    <!-- What agentic AI has done -->
                    <!-- <div class="card ai-card" id="ai-card" *ngIf="activity_data.past_activities.length > 0"> -->
                    <div class="card ai-card" id="ai-card">
                        <div class="section-title collapsible-header" (click)="toggleCard('ai-card')">
                            <div class="section-title-left">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="13px" height="13px" fill="currentColor">
                                    <path d="M234.7 427.3L128 320.7 309.3 139.4l106.7 106.7L234.7 427.3zM34.6 381.4c-46.2-46.2-46.2-121.1 0-167.3L225.8 22.8c46.2-46.2 121.1-46.2 167.3 0s46.2 121.1 0 167.3L201.9 381.4c-46.2 46.2-121.1 46.2-167.3 0zM512 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0z"/>
                                </svg> 
                                What agentic AI has done
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px" fill="currentColor" class="accordion-icon">
                                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                            </svg>
                        </div>
                        
                        <div class="collapsible-body">
                            <div class="agent-timeline">
                                <div class="timeline-item" *ngFor="let timeline of activity_data.past_activities; let isFirst = first; let isLast = last">
                                    <div class="timeline-dot" *ngIf="!isLast">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="6px" height="6px" fill="currentColor">
                                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                        </svg>
                                    </div>
                                    <div class="timeline-dot" *ngIf="isLast">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="5px" height="5px" fill="currentColor">
                                            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/>
                                        </svg>
                                    </div>
                                    <div class="timeline-content">
                                        <div class="timeline-row">
                                            <span class="timeline-action">{{timeline.name}}</span>
                                            <span class="status-pill" [ngClass]="{'completed': timeline.status_name == 'Completed', 'scheduled': timeline.status_name == 'In Progress'}">{{timeline.status_name}}</span>
                                        </div>
                                        <div class="timeline-meta">{{timeline.communication_type_name}} &bull; {{timeline.scheduled_date | date: 'dd MMM yyyy'}}</div>
                                    </div>
                                </div>

                                <!-- <div class="timeline-item">
                                    <div class="timeline-dot">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="6px" height="6px" fill="currentColor">
                                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                        </svg>
                                    </div>
                                    <div class="timeline-content">
                                        <div class="timeline-row">
                                            <span class="timeline-action">Personalised reallocation summary sent</span>
                                            <span class="status-pill completed">Completed</span>
                                        </div>
                                        <div class="timeline-meta">Email &bull; Aug 18, 2026</div>
                                    </div>
                                </div>

                                <div class="timeline-item">
                                    <div class="timeline-dot">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="6px" height="6px" fill="currentColor">
                                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                        </svg>
                                    </div>
                                    <div class="timeline-content">
                                        <div class="timeline-row">
                                            <span class="timeline-action">Follow-up nudge on maturity date</span>
                                            <span class="status-pill completed">Completed</span>
                                        </div>
                                        <div class="timeline-meta">WhatsApp &bull; Aug 25, 2026</div>
                                    </div>
                                </div>

                                <div class="timeline-item">
                                    <div class="timeline-dot">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="6px" height="6px" fill="currentColor">
                                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                        </svg>
                                    </div>
                                    <div class="timeline-content">
                                        <div class="timeline-row">
                                            <span class="timeline-action">Client opened proposal twice</span>
                                            <span class="status-pill completed">Completed</span>
                                        </div>
                                        <div class="timeline-meta">Other &bull; Aug 28, 2026</div>
                                    </div>
                                </div>

                                <div class="timeline-item">
                                    <div class="timeline-dot">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="5px" height="5px" fill="currentColor">
                                            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/>
                                        </svg>
                                    </div>
                                    <div class="timeline-content">
                                        <div class="timeline-row">
                                            <span class="timeline-action">Advisor call slot proposed</span>
                                            <span class="status-pill scheduled">Scheduled</span>
                                        </div>
                                        <div class="timeline-meta">Call &bull; Sep 3, 2026</div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <!-- Attachments Card -->
                    <div class="card collapsed" id="attachments-card">
                        <div class="section-title collapsible-header" (click)="toggleCard('attachments-card')">
                            <div class="section-title-left">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="13px" height="13px" fill="currentColor">
                                    <path d="M338.5 145.6c14.2 14.2 14.2 37.2 0 51.4L218.4 317.1c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1L212.7 94.7c39.1-39.1 102.4-39.1 141.5 0s39.1 102.4 0 141.5L168.6 421.9c-23.4 23.4-61.4 23.4-84.9 0s-23.4-61.4 0-84.9L254.3 166.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L106.3 359.6c-10.9 10.9-10.9 28.6 0 39.5s28.6 10.9 39.5 0L316 231.2c26.6-26.6 26.6-69.8 0-96.5s-69.8-26.6-96.5 0L87 267.5c-42.2 42.2-42.2 110.6 0 152.8s110.6 42.2 152.8 0L411 245.9c62.5-62.5 62.5-163.8 0-226.3s-163.8-62.5-226.3 0L24.8 159.5c-33.3 33.3-33.3 87.4 0 120.7s87.4 33.3 120.7 0l113.1-113.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L168.1 302.8c-20.8 20.8-54.6 20.8-75.4 0s-20.8-54.6 0-75.4L222.9 98c26.6-26.6 69.8-26.6 96.5 0s26.6 69.8 0 96.5L149.7 363.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L285.5 159.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L138.4 332c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2L228.4 83.3c46.8-46.8 122.8-46.8 169.6 0s46.8 122.8 0 169.6L219 422c-58.5 58.5-153.4 58.5-211.9 0s-58.5-153.4 0-211.9L170.8 40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L24.8 232.7c-45.9 45.9-45.9 120.3 0 166.2s120.3 45.9 166.2 0L360.7 231.2c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0L74.4 285.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L225.5 89.4c43.8-43.8 114.8-43.8 158.6 0s43.8 114.8 0 158.6L205.9 426.3c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L240.2 122c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L92.7 313.1c-25 25-25 65.5 0 90.5s65.5 25 90.5 0L361.6 235.2c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0L57.2 268c-18.7 18.7-18.7 49.1 0 67.8s49.1 18.7 67.8 0L294.3 168c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L147.6 358.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L338.5 210.6c14.2-14.2 14.2-37.2 0-51.4z"/>
                                </svg>
                                Attachments
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;" class="accordion-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px" fill="currentColor">
                                    <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                </svg>
                            </div>
                            
                        </div>
                        <div class="collapsible-body">
                            <div style="text-align: right;">
                                <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
                                <button class="add-action-btn" (click)="file_upload.click()" *ngIf="!task_attachment_loader">+ Add Attachment</button>
                                <button class="add-action-btn" *ngIf="task_attachment_loader">Adding Attachment . . .</button>
                            </div>
                            <div class="attachment-list">
                                <div class="attachment-item" *ngFor="let attachment of activity_data.attachments" (click)="download(attachment.attachment_download_link)">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="13px" height="13px" fill="currentColor">
                                        <path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"/>
                                    </svg> {{attachment.attachment_filename}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Comments Card -->
                    <div class="card collapsed" id="comments-card">
                        <div class="section-title collapsible-header" (click)="toggleCard('comments-card')">
                            <div class="section-title-left">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px" fill="currentColor">
                                <path d="M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c114.6 0 208-93.1 208-208S370.6 32 256 32S48 125.1 48 240c0 43.8 13 84.4 35.3 118.2c7.7 11.8 9.9 26.7 5.9 40.4l-14.7 50.7 53.3-18c12.5-4.2 26.2-2.1 36.8 5.6zM64 240C64 139.6 145.6 58 246 58s182 81.6 182 182s-81.6 182-182 182c-31.7 0-61.9-8.1-88.3-22.5c-15.1-8.2-33-8.8-48.5-1.6l-37 12.5 10.3-35.6c4-13.8 1-28.7-7.4-40.2C22.6 312.4 16 277.6 16 240c0-121.5 98.5-220 220-220S456 118.5 456 240s-98.5 220-220 220c-35.5 0-69-8.7-98.7-24.1c-16.7 8.9-35.8 13.9-56.1 13.9c-20.7 0-40.2-5.7-57.1-15.7c-9.9-5.9-22-6.5-32.4-1.8l-37 16.7L23 459c-6.8 3.1-14.5 1.5-19.8-3.8s-6.9-13-3.8-19.8l16.7-37c4.7-10.4 4.1-22.5-1.8-32.4C7.7 348.9 0 329.4 0 308.7c0-20.3 5-39.4 13.9-56.1C8.7 222.9 0 189.4 0 153.9C0 68.9 68.9 0 153.9 0c35.5 0 69 8.7 98.7 24.1C282.4 8.7 315.9 0 351.4 0C436.4 0 505.3 68.9 505.3 153.9c0 35.5-8.7 69-24.1 98.7c15.4 29.7 24.1 63.2 24.1 98.7c0 85-68.9 153.9-153.9 153.9c-35.5 0-69-8.7-98.7-24.1c-29.7 15.4-63.2 24.1-98.7 24.1c-10.6 0-21-1.1-31.2-3.3z"/>
                                </svg> Comments
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <!-- <button class="add-action-btn">
                                    + Add Comment
                                </button> -->
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px" fill="currentColor" class="accordion-icon">
                                    <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                </svg>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px" fill="currentColor">
                                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                </svg> -->
                            </div>
                        </div>
                        <div class="collapsible-body">
                            <div class="attachment-list">
                                <div class="comment-item" *ngFor="let comment of activity_data.comments">
                                    <strong>{{comment.description}}</strong><br>
                                    {{comment.commented_by_name}} &bull; {{comment.comment_date | date: "MMM d, y, h:mm:ss a"}}
                                </div>
                                <div class="comment-input-container">
                                    <div class="comment-textarea-wrapper" [ngClass]="{'custom-input-error': comment_error}" *ngIf="!comment_loader">
                                        <textarea placeholder="Write a comment..." [(ngModel)]="comment"></textarea>
                                        <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20px" height="20px" fill="#10B981" (click)="addComment()"> -->
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20px" height="20px" fill="#2563eb" (click)="addComment()">
                                            <path d="M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-72.1-48.3zM144 339.4L55.4 303c-5.8-2.4-7.2-10.2-2.7-14.4L393.2 52.8c4.2-3.9 10.2-2.9 12.6 2.1l-261.8 284.5zM232 440c0 4.4-3.6 8-8 8s-8-3.6-8-8v-43.2l24-9.9V440zm12.3-70.8l-72.3-29.9L403.4 86.6c4.5-4.5 11.8-3.2 14.4 2.5L244.3 369.2z"/>
                                        </svg>
                                    </div>
                                    <button class="add-action-btn" *ngIf="comment_loader">Adding Comment . . .</button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="card collapsed" id="proposals-card" *ngIf="user_role == 'Advisor' || user_role == 'AFA'">
                        <div class="section-title collapsible-header" (click)="toggleCard('proposals-card')">
                            <div class="section-title-left">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                    <line points="16 13 8 13"></line>
                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                    <polyline points="10 9 9 9 8 9"></polyline>
                                </svg> Proposals
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px" fill="currentColor" class="accordion-icon">
                                    <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                </svg>
                            </div>
                        </div>
                        <div class="collapsible-body">
                            <div style="text-align: right;">
                                <button class="add-action-btn" (click)="openSendProposalModal({}, 'Create')" *ngIf="!send_proposal_loader">+ Add Proposal</button>
                            </div>
                            <div class="attachment-list">
                                <div class="proposal-card" *ngFor="let document of activity_data.documents">
                                    <div class="card-left">
                                        <div class="icon-wrapper">
                                            <!-- Document SVG Icon -->
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                                <polyline points="14 2 14 8 20 8"></polyline>
                                                <line x1="16" y1="13" x2="8" y2="13"></line>
                                                <line x1="16" y1="17" x2="8" y2="17"></line>
                                                <line x1="10" y1="9" x2="8" y2="9"></line>
                                            </svg>
                                        </div>
                                        <div class="proposal-info">
                                            <h3>{{document.product_name}}</h3>
                                            <!-- <p class="proposal-meta">Created {{document.proposal_sent_date | date: "dd MMM yyyy"}} &nbsp;|&nbsp; {{document.product_name}}</p> -->
                                            <p class="proposal-meta">Scheduled for {{document.scheduled_date | date: "dd MMM yyyy"}}</p>
                                        </div>
                                    </div>

                                    <div class="card-right">
                                        <span class="badge-sent" *ngIf="!document.is_sent" (click)="openSendProposalModal(document, 'Edit')">Edit</span>
                                        <span class="badge-sent" (click)="viewProposal(document)">View</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="complete-btn" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 1 || activity_data.activity_type == 2)" (click)="openCloseDealModal()">
                        Capture Results
                    </div>

                    <div class="complete-btn" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 3 || activity_data.activity_type == 5)" (click)="openChangeOutcomeModal()">
                        Capture Results
                    </div>

                    <div class="complete-btn" (click)="openCaptureresultsModal()" [matTooltip]="'Capture Results'" *ngIf="user_role == 'Wholesaler' || user_role == 'Leadership'">
                        Capture Results
                    </div>

                </div>

                <!-- Right Column -->
                <div class="right-column">
                    <div class="card" style="flex-grow: 1;">
                        <div class="move-header">What should you do now?</div>
                        <!-- <div class="move-subheader">Choose communication channel & log interaction details</div> -->

                        <div class="channel-grid">
                            <div class="channel-btn" *ngFor="let action of activity_data.action_list" [ngClass]="{'active': activity_data.comm_id == action.comm_id}" (click)="activity_data.comm_id = action.comm_id; activityQuickAction();">
                                {{action.action_name}}
                            </div>
                        </div>

                        <ng-container *ngIf="activity_data.comm_id != '' && activity_data.comm_id != null">
                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label">Scheduled Date</label>
                                    <!-- <div class="custom-input">
                                        <span>Pick a date</span>
                                        <i class="fa-regular fa-calendar"></i>
                                    </div> -->
                                    <input
                                        type="text"
                                        class="custom-input"
                                        bsDatepicker
                                        placement="bottom"
                                        [(ngModel)]="activity_data.scheduled_date"
                                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                        [ngClass]="{'custom-input-error': activity_schedule_date_error}"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Actual Date</label>
                                    <!-- <div class="custom-input">
                                        <span>Pick a date</span>
                                        <i class="fa-regular fa-calendar"></i>
                                    </div> -->
                                    <input
                                        type="text"
                                        class="custom-input"
                                        bsDatepicker
                                        placement="bottom"
                                        [(ngModel)]="activity_data.actual_date"
                                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                        [ngClass]="{'custom-input-error': activity_actual_date_error}"
                                    />
                                </div>
                            </div>

                            <div class="form-group">
                                <!-- <label class="form-label">Status</label> -->
                                <label class="form-label">Activity Status</label>
                                <div class="status-options">
                                    <div class="status-option-btn" *ngFor="let status of status_list" [ngClass]="{'active': activity_data.status == status.id}" (click)="activity_data.status = status.id">
                                        {{status.name}}
                                    </div>
                                    <!-- <div class="status-option-btn">Open</div>
                                    <div class="status-option-btn active">In Progress</div>
                                    <div class="status-option-btn">Completed</div> -->
                                </div>
                            </div>

                            <ng-container *ngIf="user_role == 'Advisor' || user_role == 'AFA' || user_role == 'Assistant'">
                                <div class="form-group">
                                    <label class="form-label">Response</label>
                                    <div class="response-options">
                                        <!-- <div class="response-btn">
                                            <i class="fa-regular fa-thumbs-up"></i> Interested
                                        </div>
                                        <div class="response-btn">
                                            <i class="fa-regular fa-thumbs-down"></i> Not Interested
                                        </div> -->
                                        <div class="response-btn" *ngFor="let response_option of response_options_list" [ngClass]="{'active': activity_data.capture_response.response_status == response_option.name}" (click)="activity_data.capture_response.response_status = response_option.name">
                                            {{response_option.name}}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Notes</label>
                                    <div class="custom-input" style="padding: 0;">
                                        <!-- <textarea placeholder="Add a quick note.."></textarea> -->
                                        <app-textarea-tagging style="width: 100%; color: #000000;" [value]="activity_data.capture_response.response_comments" [users]="tagging_users_list" [placeholder]="'Notes ...'" (valueChanged)="activity_data.capture_response.response_comments = $event"></app-textarea-tagging>
                                    </div>
                                </div>
                            </ng-container>

                        </ng-container>

                    </div>
                    <!-- Bottom Footer Bar -->
                    <!-- <div class="bottom-action-card">
                        <div class="form-label" style="font-size: 12px; color: #94A3B8;">Define the next step</div>
                        <div class="bottom-grid">
                            <input class="custom-input" /> 
                            <select class="custom-input">
                                <option [value]="''">Select Channel</option>
                                <option *ngFor="let communication_channel of communication_type_list" [value]="communication_channel.id">{{communication_channel.name}}</option>
                            </select>
                            <input
                                type="text"
                                class="custom-input"
                                bsDatepicker
                                placement="bottom"
                                [(ngModel)]="activity_data.actual_date"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                [ngClass]="{'custom-input-error': activity_actual_date_error}"
                            />
                        </div>
                    </div> -->


                    <div class="next-steps-container" style="flex-grow: 1;">
                        <div class="header-section">
                            <h2>Next steps</h2>
                            <button class="add-btn" (click)="followUpTaskOperations(follow_up_task_data, index, 'Add')">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                Add next step
                            </button>
                        </div>

                        <div class="table-header" *ngIf="activity_data.followup_activities.length > 0">
                            <span>Step</span>
                            <span>Activity</span>
                            <span>Description</span>
                            <span>Due date</span>
                            <!-- <span>Edit / Save</span> -->
                            <span>Actions</span>
                        </div>

                        <ng-container *ngFor="let follow_up_task of activity_data.followup_activities; let index = index;">
                            <div class="step-row">
                                <div class="step-badge">{{index + 1}}</div>
                                <ng-container *ngIf="follow_up_task_index != index">
                                    <div class="input-box select-box">
                                        <span>{{follow_up_task.channel_name}}</span>
                                    </div>
                                    <div class="input-box select-box">
                                        <span>{{follow_up_task.name}}</span>
                                    </div>
                                    <div class="input-box">
                                        <span>{{follow_up_task.scheduled_date | date: "dd MMM yyyy"}}</span>
                                    </div>
                                    <div class="action-buttons">
                                        <button class="icon-btn" *ngIf="follow_up_task.channel == 10" (click)="openScheduleMeetingModal('action-item', index)">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                <line x1="3" y1="10" x2="21" y2="10" />
                                                <line x1="8" y1="2" x2="8" y2="6" />
                                                <line x1="16" y1="2" x2="16" y2="6" />
                                                <circle cx="16" cy="16" r="4" fill="currentColor" stroke="none" />
                                                <polyline points="16,14 16,16 17.5,17.5" fill="none" stroke="#ffffff" stroke-width="1.5" />
                                            </svg>
                                        </button>
                                        <button class="icon-btn" (click)="followUpTaskOperations(follow_up_task, index, 'Edit')">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                            </svg>
                                        </button>
                                        <button class="icon-btn delete" (click)="deleteFollowUpTask(index)" *ngIf="!follow_up_task.id">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="follow_up_task_index == index">
                                    <div>
                                        <select class="custom-input" [(ngModel)]="follow_up_task_data.channel" [ngClass]="{'custom-input-error': follow_up_task_data_errors.channel}" (change)="onChannelSelected(follow_up_task_data.channel)">
                                            <option [value]="''">Select Activity</option>
                                            <option *ngFor="let communication_channel of communication_type_list" [value]="communication_channel.id" (click)="follow_up_task_data.channel_name = communication_channel.name">{{communication_channel.name}}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <input placeholder="Description . . ." class="custom-input" [(ngModel)]="follow_up_task_data.name" [ngClass]="{'custom-input-error': follow_up_task_data_errors.name}" /> 
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                             placeholder="Due Date . . ."
                                            class="custom-input"
                                            bsDatepicker
                                            placement="left"
                                            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                            [(ngModel)]="follow_up_task_data.scheduled_date"
                                            [ngClass]="{'custom-input-error': follow_up_task_data_errors.scheduled_date}"
                                        />
                                    </div>
                                    <div class="action-buttons">
                                        <button class="icon-btn save-icon-btn" (click)="saveFollowUpTask()">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                        </button>
                                        <button class="icon-btn cancel-icon-btn" (click)="resetFollowUpTask()">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                        <div class="step-row" *ngIf="follow_up_task_type == 'Add' && follow_up_task_index == null">
                            <div class="step-badge">{{activity_data.followup_activities.length + 1}}</div>
                            <ng-container>
                                <div>
                                    <select class="custom-input" [(ngModel)]="follow_up_task_data.channel" [ngClass]="{'custom-input-error': follow_up_task_data_errors.channel}" (change)="onChannelSelected(follow_up_task_data.channel)">
                                        <option [value]="''">Select Activity</option>
                                        <option *ngFor="let communication_channel of communication_type_list" [value]="communication_channel.id" (click)="follow_up_task_data.channel_name = communication_channel.name;">{{communication_channel.name}}</option>
                                    </select>
                                </div>
                                <div>
                                    <input placeholder="Description . . ." class="custom-input" [(ngModel)]="follow_up_task_data.name" [ngClass]="{'custom-input-error': follow_up_task_data_errors.name}" /> 
                                </div>
                                <div>
                                    <input
                                        type="text"
                                         placeholder="Due Date . . ."
                                        class="custom-input"
                                        bsDatepicker
                                        placement="left"
                                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                        [(ngModel)]="follow_up_task_data.scheduled_date"
                                        [ngClass]="{'custom-input-error': follow_up_task_data_errors.scheduled_date}"
                                    />
                                </div>
                                <div class="action-buttons">
                                    <button class="icon-btn save-icon-btn" (click)="saveFollowUpTask()">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                    </button>
                                    <button class="icon-btn cancel-icon-btn" (click)="resetFollowUpTask()">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <button class="complete-btn" (click)="saveActivityData()" *ngIf="!activity_save_loader">Complete action & schedule next step</button>
                    <button class="complete-btn" *ngIf="activity_save_loader">Saving . . .</button>
                </div>

                <ng-container *ngIf="show_send_proosal">
                    <div class="proposal-modal">
                        <!-- Header -->
                        <div class="proposal-modal-header">
                            <div class="header-title-area">
                                <div class="header-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                        <polyline points="14 2 14 8 20 8"></polyline>
                                        <line points="16 13 8 13"></line>
                                        <line x1="16" y1="17" x2="8" y2="17"></line>
                                        <polyline points="10 9 9 9 8 9"></polyline>
                                    </svg>
                                </div>
                                <div>
                                    <!-- <h2>Create Proposal</h2> -->
                                    <!-- <p>Create and send a proposal to {{activity_data.user_name}}</p> -->
                                    <h2>{{proposal_data_type}} Proposal</h2>
                                    <p>{{proposal_data_type}} and send a proposal to {{activity_data.user_name}}</p>
                                </div>
                            </div>
                            <button class="close-btn" (click)="closeSendProposalModal()">
                                <!-- Close X Icon SVG -->
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>

                        <div class="proposal-modal-content-section">
                            <!-- Objective Field -->
                            <div class="form-group">
                                <label>Objective *</label>
                                <select class="custom-input"  [(ngModel)]="proposal_data.objective_code" [ngClass]="{'custom-input-error': proposal_data_errors.objective_code}">
                                    <option [value]="''">Select Objective</option>
                                    <option *ngFor="let objective of objectives_list" [value]="objective.objective_code">{{objective.objective}}</option>
                                </select>
                            </div>

                            <!-- Product Field -->
                            <div class="form-group">
                                <label>Product *</label>
                                <select class="custom-input" [(ngModel)]="proposal_data.product" [ngClass]="{'custom-input-error': proposal_data_errors.product}">
                                    <option [value]="''">Select Product</option>
                                    <option *ngFor="let product of products_list" [value]="product.id">{{product.name}}</option>
                                </select>
                            </div>

                            <!-- Scheduled Date -->
                            <div class="form-group">
                                <label>Scheduled Date *</label>
                                <input
                                    type="text"
                                    class="page-modal-input"
                                    bsDatepicker
                                    [minDate]="current_date"
                                    [(ngModel)]="proposal_data.scheduled_date"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    [ngClass]="{'custom-input-error': proposal_data_errors.scheduled_date}"
                                />
                            </div>

                            <!-- Proposal Documents -->
                            <div class="form-group">
                                <label>Proposal Documents *</label>
                                <input type="file" multiple style="display: none;" #proposalFile (change)="uploadProposalFile($event)" />
                                <div class="upload-box" (click)="proposalFile.click()" [ngClass]="{'custom-input-error': proposal_data_errors.files}">
                                    <!-- Upload Icon SVG -->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                        <polyline points="17 8 12 3 7 8"></polyline>
                                        <line x1="12" y1="3" x2="12" y2="15"></line>
                                    </svg>
                                    <div class="upload-text">Click to upload or drag and drop</div>
                                    <div class="upload-subtext">PDF, DOC, DOCX, XLS, XLSX (Max 10MB)</div>
                                </div>
                            </div>

                            <div class="each-proposal-document-section" *ngFor="let file of proposal_data.documents; let index = index">
                                <span>{{file.document_file_name}}</span>
                                <span class="each-proposal-document-remove-icon" (click)="deleteProposalFile(index)">&times;</span>
                            </div>

                            <!-- Subject -->
                            <div class="form-group">
                                <label>Subject *</label>
                                <input type="text" class="custom-input" [(ngModel)]="proposal_data.subject" [ngClass]="{'custom-input-error': proposal_data_errors.subject}" />
                            </div>

                            <!-- Email Body -->
                            <div class="form-group">
                                <label>Email Body *</label>
                                <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="proposal_data.email_body" [config]="editorConfig" [ngClass]="{'custom-input-error': proposal_data_errors.email_body}"></angular-editor>
                            </div>

                        </div>

                        <!-- Footer Buttons -->
                        <div class="proposal-modal-footer">
                            <button class="action action-secondary" (click)="closeSendProposalModal()">Cancel</button>
                            <button class="action action-primary" (click)="sendProposal()" *ngIf="!send_proposal_loader">
                                <!-- Send Icon SVG -->
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <line x1="22" y1="2" x2="11" y2="13"></line>
                                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                </svg>
                                Send Proposal
                            </button>
                            <button class="action action-primary" (click)="sendProposal()" *ngIf="send_proposal_loader">
                                <!-- Send Icon SVG -->
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <line x1="22" y1="2" x2="11" y2="13"></line>
                                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                </svg>
                                Sending Proposal . . .
                            </button>
                        </div>
                    </div>
                </ng-container>
                

            </div>

        </div>
    </ng-container>
    <ng-container *ngIf="!activity_data_loaded">
        <app-loader [loading_text]="'Loading'"></app-loader>
    </ng-container>
</div>

<ng-template #viewProposalModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<!-- <span class="modal-heading">View Document</span> -->
			<span class="modal-heading">View Proposal</span>
			<span class="page-modal-close-icon" (click)="closeViewProposalModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Document Sent Date</p>
				<p class="page-modal-input">{{view_proposal_data.proposal_sent_date | date: 'dd MMM yyyy'}}</p>
				<!-- <p class="page-modal-input">{{view_proposal_data.scheduled_date | date: 'dd MMM yyyy'}}</p> -->
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Product</p>
				<p class="page-modal-input">{{view_proposal_data.product_name}}</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Objective</p>
				<p class="page-modal-input">{{view_proposal_data.objective}}</p>
			</div>
            <div class="page-modal-input-section">
				<p class="page-modal-input-label">Subject</p>
				<p class="page-modal-input">{{view_proposal_data.subject}}</p>
			</div>
            <div class="page-modal-input-section">
				<p class="page-modal-input-label">Email Body</p>
				<p class="page-modal-input" [innerHTML]="view_proposal_data.email_body" style="white-space: normal;"></p>
			</div>
			<!-- <div class="page-modal-input-section">
				<p class="page-modal-input-label">Status</p>
				<span class="activity-table-tag" [ngClass]="{'high-importance-tag': view_proposal_data.proposal_status == 1, 'medium-importance-tag': view_proposal_data.proposal_status == 2, 'low-importance-tag': view_proposal_data.proposal_status == 3}">{{view_proposal_data.proposal_status_name}}</span>
			</div> -->
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Documents</p>
				<div class="each-proposal-document-section" *ngFor="let file of view_proposal_data.documents; let index = index">
					<span>{{file.document_file_name}}</span>
					<!-- <span class="each-proposal-document-remove-icon" (click)="download(file.document)">&#x2193;</span> -->
					<img src="assets/attachment-download.png" class="each-proposal-document-remove-icon" (click)="download(file.document)" />

				</div>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="closeViewProposalModal()">Close</button>
		</div>
	</div>
</ng-template>

<ng-template #scheduleMeetingModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span class="modal-heading">Schedule Meeting</span>
            <span class="page-modal-close-icon" (click)="closeScheduleMeetingModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Topic *</p>
                    <input type="text" class="capture-response-input" [(ngModel)]="meeting_data.topic" />
                    <p class="input-error" *ngIf="meeting_data_errors.topic">Topic is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <!-- <p class="capture-response-input-label">Description</p> -->
                    <p class="capture-response-input-label">Meeting Notes *</p>
                    <!-- <app-textarea-tagging [value]="meeting_data.description" [users]="[]" [placeholder]="'Description ...'" (valueChanged)="meeting_data.description = $event"></app-textarea-tagging> -->
                    <app-textarea-tagging [value]="meeting_data.description" [users]="[]" [placeholder]="'Meeting Notes ...'" (valueChanged)="meeting_data.description = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="meeting_data_errors.description">Description is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(100% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <!-- <p class="capture-response-input-label">Attendees</p> -->
                    <p class="capture-response-input-label">Invite Others(Optional)</p>
                    <mat-chip-list #attendeesEmailList>
                        <mat-chip *ngFor="let email of meeting_data.attendees" [removable]="true" (removed)="removeAtteendeeEmail(email)">
                            {{email}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <div style="width: 100%;">
                            <input
                                class="capture-response-input"
                                placeholder="Attendee email..."
                                [matChipInputFor]="attendeesEmailList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="true"
                                (matChipInputTokenEnd)="addAtteendeeEmail($event)"
                            />
                        </div>
                    </mat-chip-list>
                    <div *ngIf="attendees_error" class="input-error">Invalid email address</div>
                    <p class="input-error" *ngIf="meeting_data_errors.attendees">Attendees is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(50% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">When *</p>
                    <input
                        type="text"
                        class="capture-response-input"
                        bsDatepicker
                        placement="right"
                        [(ngModel)]="meeting_data.when"
                        [minDate]="current_date"
                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                        (ngModelChange)="generateTimeSlots()"
                    />
                    <p class="input-error" *ngIf="meeting_data_errors.when">When is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(25% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Time *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.time">
                        <mat-option [value]="''">Select Time</mat-option>
                        <mat-option *ngFor="let time_slot of time_slots" [value]="time_slot">{{time_slot}}</mat-option>
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.time">Time is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: 25%;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Duration *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.duration">
                        <mat-option [value]="''">Select Duration</mat-option>
                        <mat-option *ngFor="let duration_slot of duration_slots" [value]="duration_slot.value">{{duration_slot.name}}</mat-option>
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.duration">Duration is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Timezone *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.timezone">
                        <mat-option [value]="''">Select Timezone</mat-option>
                        <mat-option *ngFor="let timezone of timezone_list" [value]="timezone.value">{{timezone.name}}</mat-option>
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.timezone">Timezone is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Platform *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.platform">
                        <mat-option [value]="''">Select Platform</mat-option>
                        <mat-option [value]="'Zoom'">Zoom</mat-option>
                        <mat-option [value]="'Google Meet'">Google Meet</mat-option>
                        
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.platform">Platform is Required.</p>
                </div>
            </div>
            <!-- <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    Commented <p class="capture-response-input-label">Attachments</p>
                    <p class="capture-response-input-label">Attachments(Optional)</p>
                    <input type="file" multiple style="display: none;" #meetingAtachmentFile (change)="uploadAtatchmentFile($event)" />
                    Commented <input type="file" style="display: none;" #meetingAtachmentFile (change)="uploadAtatchmentFile($event)" />
                    <button class="page-modal-primary-button" (click)="meetingAtachmentFile.click()">Upload</button>
                    <p class="input-error" *ngIf="meeting_data_errors.attachments">Attachments should be minimum one.</p>
                    <div class="each-proposal-document-section" *ngFor="let file of meeting_data.attachments; let index = index">
                        <span>{{file.name}}</span>
                        <span class="each-proposal-document-remove-icon" (click)="deleteAttachmentFile(index)">&times;</span>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="scheduleMeeting()">Send</button>
            <button class="page-modal-secondary-button" (click)="closeScheduleMeetingModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #closeDealModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="hideDealModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
            <ng-container>
                <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                <div class="each-activity-details-action-section">
                    <button class="page-modal-primary-button" (click)="addProduct()">Save</button>
                    <button class="page-modal-secondary-button" (click)="hideDealModal()">Cancel</button>
                </div>
            </ng-container>
		</div>
	</div>
</ng-template>

<!-- Conversion Status and Dropdown and its Products Starts -->
<ng-template #productConversionSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Conversion Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="conversion_status_data.conversion_status" >
                <mat-option [value]="''">Select Conversion Status</mat-option>
                <mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" conversion_status_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="conversion_status_data_errors.conversion_status">Conversion Status is Required.</p>
        </div>
        <div>
            <div class="capture-response-input-section" style="width: calc(100% - 24px);">
                <p class="capture-response-input-label">Comments *</p>
                <app-textarea-tagging [value]="conversion_status_data.conversion_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="conversion_status_data.conversion_comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="conversion_status_data_errors.conversion_comments">Comments is Required.</p>
            </div>
        </div>

        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="depositproductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '7'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '8'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

    </div>
</ng-template>
<!-- Conversion Status and Dropdown and its Products Ends -->



<ng-template #productOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of products_list" [value]="product.id" (click)="getProductType(product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.product">Product is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">AUM *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="product_data.aum" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="product_data_errors.aum">AUM is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Activation Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="product_data.start_date == '' || product_data.start_date == null" -->
            <p class="input-error" *ngIf="product_data_errors.start_date">Activation Date is Required.</p>
        </div>
        <div class="capture-response-input-section" *ngIf="getProductType(product_data.product)">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="product_data.close_date"
                [minDate]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="product_data_errors.close_date">Valid Until is Required.</p>
        </div>
        <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div>
        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.type">Type is Required.</p>
        </div> -->
        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div> -->
        <div class="capture-response-input-section">
            <p class="capture-response-input-label" *ngIf="user_role != 'Relationship Manager'">Policy Number</p>
            <p class="capture-response-input-label" *ngIf="user_role == 'Relationship Manager'">Deposit Number</p>
            <input type="text" class="capture-response-input" [(ngModel)]="product_data.policy_number" />
            <p class="input-error" *ngIf="product_data_errors.policy_number">
                <span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
                <span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
                is Required.
            </p>
        </div>
    </div>
</ng-template>


<!-- deposit Product Operation Section Start -->
<ng-template #depositproductOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of products_list" [value]="product.id" (click)="getProductType(depositProduct_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.aum" (input)="checkAmountValidation(depositProduct_data.product, depositProduct_data.aum)" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="depositProduct_data_errors.aum">Amount is Required.</p>
            <p class="input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="depositProduct_data_errors.start_date">Start Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.close_date"
                [minDate]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="depositProduct_data.start_date == '' || depositProduct_data.start_date == null" -->
            <p class="input-error" *ngIf="depositProduct_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.tenure" />
            <p class="input-error" *ngIf="depositProduct_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="input-error" *ngIf="depositProduct_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.monthly_fees" />
            <p class="input-error" *ngIf="depositProduct_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.type">Type is Required.</p>
        </div> -->



        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.policy_number" />
            <p class="input-error" *ngIf="depositProduct_data_errors.policy_number">Policy Number is Required.</p>
        </div>
    </div>
</ng-template>
<!-- deposit Product Operation Section End -->

<!-- Lending Product Operation Section Start -->
<ng-template #lendingProductOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of products_list" [value]="product.id" (click)="getProductType(lending_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.aum" (input)="checkAmountValidation(lending_product_data.product, lending_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="lending_product_data_errors.aum">Amount is Required.</p>
            <p class="input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="lending_product_data_errors.start_date">Start Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.close_date"
                [minDate]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="lending_product_data.start_date == '' || lending_product_data.start_date == null" -->
            <p class="input-error" *ngIf="lending_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.tenure" />
            <p class="input-error" *ngIf="lending_product_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="input-error" *ngIf="lending_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.monthly_fees" />
            <p class="input-error" *ngIf="lending_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.type">Type is Required.</p>
        </div> -->



        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.policy_number" />
            <p class="input-error" *ngIf="lending_product_data_errors.policy_number">Policy Number is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Lending Product Operation Section End -->

 <!-- Insurance Product Operation Section Start -->
<ng-template #insuranceProductOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of products_list" [value]="product.id" (click)="getProductType(insurance_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.aum" (input)="checkAmountValidation(insurance_product_data.product, insurance_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="insurance_product_data_errors.aum">Amount is Required.</p>
            <p class="input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="insurance_product_data_errors.start_date">Start Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.close_date"
                [minDate]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="insurance_product_data.start_date == '' || insurance_product_data.start_date == null" -->
            <p class="input-error" *ngIf="insurance_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.tenure" />
            <p class="input-error" *ngIf="insurance_product_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="input-error" *ngIf="insurance_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.monthly_fees" />
            <p class="input-error" *ngIf="insurance_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.type">Type is Required.</p>
        </div> -->



        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.policy_number" />
            <p class="input-error" *ngIf="insurance_product_data_errors.policy_number">Policy Number is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Insurance Product Operation Section End -->

<ng-template #changeOutcomeModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="closeChangeOutcomeModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
            <ng-container>
                <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
            </ng-container>
		</div>
		<div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeChangeOutcomeModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<ng-template #outcomeConversionSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Outcome Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="outcome_data.attrition_status" >
                <mat-option [value]="''">Select Outcome Status</mat-option>
                <mat-option [value]="'Retained'">Retained</mat-option>
                <mat-option [value]="'Retained, Upside'">Retained, Upside</mat-option>
                <mat-option [value]="'Likely to Switch Advisor'">Likely to Switch Advisor</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="outcome_data_errors.attrition_status">Outcome Status is Required.</p>
        </div>
        <ng-container *ngIf="outcome_data.attrition_status == 'Likely to Switch Advisor'">
            <div class="capture-response-input-section">
                <p class="capture-response-input-label">Reason *</p>
                <mat-select class="capture-response-input" [(ngModel)]="outcome_data.attrition_comments" >
                    <mat-option [value]="''">Select Reason</mat-option>
                    <mat-option *ngFor="let attrition_reason of attrition_reasons_list" [value]="attrition_reason.name">{{attrition_reason.name}}</mat-option>
                </mat-select>
                <p class="input-error" *ngIf="outcome_data_errors.attrition_comments">Reason is Required.</p>
            </div>
        </ng-container>
        <div *ngIf="outcome_data.attrition_status != 'Likely to Switch Advisor'">
            <div class="capture-response-input-section" style="width: calc(100% - 24px);">
                <p class="capture-response-input-label">Comments *</p>
                <app-textarea-tagging [value]="outcome_data.attrition_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="outcome_data.attrition_comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="outcome_data_errors.attrition_comments">Comments is Required.</p>
            </div>
        </div>

        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
        </ng-container>


        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="depositproductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '7'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '8'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #captureresultsModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="hideCaptureresultsModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
            <ng-container>
                <div class="capture-response-section">
                    <div class="capture-response-input-section">
                        <p class="capture-response-input-label">Appointment Status *</p>
                        <mat-select class="capture-response-input" [(ngModel)]="capture_results_data.appointment_status_id" >
                            <mat-option [value]="''">Select Appointment Status</mat-option>
                            <mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" capture_results_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
                        </mat-select>
                        <p class="input-error" *ngIf="capture_results_data_errors.appointment_status_id">Appointment Status is Required.</p>
                    </div>
                    <div>
                        <div class="capture-response-input-section" style="width: 100%;">
                            <p class="capture-response-input-label">Comments *</p>
                            <app-textarea-tagging [value]="capture_results_data.appointment_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="capture_results_data.appointment_comments = $event"></app-textarea-tagging>
                            <p class="input-error" *ngIf="capture_results_data_errors.appointment_comments">Comments is Required.</p>
                        </div>
                    </div>
                </div>
                <div class="each-activity-details-action-section">
                    <button class="page-modal-primary-button" (click)="saveCaptureResultsData()">Save</button>
                    <button class="page-modal-secondary-button" (click)="hideCaptureresultsModal()">Cancel</button>
                </div>
            </ng-container>
		</div>
	</div>
</ng-template>

<ng-template #activityEmailPreviewModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span *ngIf="activity_email_data_loaded">{{ activity_email_data.template_name }}</span>
            <span class="page-modal-close-icon" (click)="closeActivityEmailPreviewModal()">&times;</span>
        </div>
        <div class="page-modal-content-section" *ngIf="activity_email_data_loaded">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label" style="font-weight: 600;">Subject: {{ activity_email_data.subject }}</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label" style="font-weight: 600;">Email Body:</p>
                <p class="page-modal-input-label" [innerHTML]="getHTML(activity_email_data.email_body)">{{ activity_email_data.template_name }}</p>
            </div>
            <div class="page-modal-input-section" *ngIf=" activity_email_data.greetings_image != '' && activity_email_data.greetings_image != null ">
                <button class="page-modal-primary-button" (click)="download(activity_email_data.greetings_image)" >Download Attachment</button>
            </div>
        </div>
        <div class="page-modal-content-section" *ngIf="!activity_email_data_loaded">
            <app-loader [loading_text]="'Loading'"></app-loader>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="closeActivityEmailPreviewModal()">Cancel</button>
        </div>
    </div>
</ng-template>